var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graph"},[_vm._v(" Vesting Schedule for "+_vm._s(_vm.tab)+" "),_c('graph',{attrs:{"width":300,"height":300,"chartData":_vm.chartData(),"options":_vm.chartOptions()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }